<template>
  <div>
    <h2>Dropbox Auth</h2>
    <div v-if="this.dropboxLoggedIn">
      <p>Dropbox acccount: {{dropboxDisplayName}}</p>
      <b-button @click="deauth">Deauth</b-button>
    </div>
    <div v-else>
      <b-button @click="auth">Auth</b-button>
    </div>
  </div>
</template>

<script>
import { mapGetters } from "vuex";
import utils from "@/js/utils";
import fb from "@/firebaseConfig";
import dbx from "@/dropboxConfig";

export default {
  data() {
    return {
      dbx_account_name: ""
    };
  },
  methods: {
    auth() {
      const token = utils.randomString(32);
      this.$cookies.set("dbx_csrf", token, "2min");

      const oauthRedirectUrl =
        window.location.origin +
        this.$router.resolve({ name: "dropboxoauth" }).href;
      const authUrl = dbx.getAuthenticationUrl(
        oauthRedirectUrl,
        token,
        "token"
      );
      location.href = authUrl;
    },
    deauth() {
      fb.db
        .collection("users")
        .doc(this.user.details.uid)
        .update({ dbx_token: "" })
        .then(() => {
          console.log("Dropbox token in user state set to ''");
        })
        .catch(err => {
          alert(err);
        });
    }
  },
  computed: {
    ...mapGetters({
      user: "user/user",
      dropboxUsersFullAccount: "dropbox/usersFullAccount",
      dropboxLoggedIn: "dropbox/loggedIn",
      site: "site"
    }),
    dropboxDisplayName() {
      if (this.dropboxLoggedIn) {
        return this.dropboxUsersFullAccount.name.display_name;
      } else {
        return "";
      }
    }
  }
};
</script>

<style>
</style>